"use client"

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactNode, useState } from 'react'

export function QueryProvider({ children }: { children: ReactNode }) {
    const [queryClient] = useState(() => new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 0, // Always refetch on mount for fresh data
                gcTime: 1000 * 60 * 5, // 5 minutes - keep in cache for smooth navigation
                retry: 1, // Retry failed requests once
                refetchOnWindowFocus: false,
                refetchOnMount: true,
                refetchOnReconnect: true,
            },
        },
    }))

    return (
        <QueryClientProvider client={queryClient}>
            {children}
        </QueryClientProvider>
    )
}
